module.exports = __webpack_public_path__ + "img/close.d26203b4.png";